import { render } from "./InviteCard.vue?vue&type=template&id=6981b746&scoped=true"
import script from "./InviteCard.vue?vue&type=script&lang=js"
export * from "./InviteCard.vue?vue&type=script&lang=js"

import "./InviteCard.vue?vue&type=style&index=0&id=6981b746&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6981b746"]])

export default __exports__